export default __webpack_public_path__ + "static/media/8.5188f991.png";